<template>
  <div class="sky-deploy-step-view-requiremnet-check">
    <div class="case-requirement">
      <div class="wsp-group-title">
        <div class="wsp-group-title-icon"></div>
        <div class="wsp-group-title-value">关键需求</div>
        <div class="wsp-group-title-tip">
          <el-button type="primary" @click="addFunction">添加功能</el-button>
        </div>
      </div>
      <div class="case-requirement-content">
        <div class="content-tag">
          <div class="tag-content wsp-display-flex wsp-display-flex-warp">
            <div
              v-for="(featureValue, key) in featureValueList"
              :key="key"
              :class="`wsp-padding-3 wsp-margin-3 wsp-border tag-item ${featureTag === featureValue ? 'active' : ''}`"
              @click="featureViewList(featureValue)"
            >
              {{ featureValue }}
            </div>
          </div>
        </div>
        <div class="content-function wsp-display-flex wsp-display-flex-warp wsp-line-height-28">
          <div
            v-for="(featureItem, index) in viewFeatureList"
            :key="index"
            :class="
              `wsp-width-24 wsp-border function-item wsp-margin-3 wsp-border-radius-6 wsp-handel-point ${
                featureItem.export ? 'featur-active' : ''
              }`
            "
            @click="changeExport(featureItem)"
          >
            <div :class="`function-item-icon`"></div>
            <div class="function-item-content">
              <div class="wsp-text-align-center wsp-padding-tb-3 font-size-18">{{ featureItem.featureName }}</div>
              <div class="wsp-display-flex">
                <div class="wsp-width-30 wsp-text-align-right"><strong>价值：</strong></div>
                <div class="wsp-width-70">{{ featureItem.valueDesc }}</div>
              </div>
              <div class="wsp-display-flex">
                <div class="wsp-width-30 wsp-text-align-right"><strong>适用岗位：</strong></div>
                <div class="wsp-width-70 match-position">
                  <el-tag type="success" v-if="featureItem.positionIdList.length === 0">全部</el-tag>
                  <el-tag
                    v-else
                    v-for="(positionId, positionIndex) in featureItem.positionIdList"
                    :key="positionIndex"
                    @close="removeFuntionPosition(featureItem, index, positionId, positionIndex)"
                    closable
                    >{{ positionMap[positionId] ? positionMap[positionId].name : '无' }}</el-tag
                  >

                  <el-dropdown
                    placement="bottom-end"
                    @command="handlePositionCommand"
                    trigger="click"
                    :hide-on-click="false"
                  >
                    <el-button
                      type="text"
                      size="mini"
                      icon="el-icon-plus"
                      circle
                      @click="clickHandelFeature(featureItem, index)"
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(positionItem, key) in positionMap"
                        :key="key"
                        :command="key"
                        :disabled="featureItem.positionIdList.includes(key)"
                        >{{ positionItem.name }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>

            <div class="funtion-item-toolbar wsp-display-flex-right">
              <div class="wsp-padding-lr-3">
                <el-button type="text" @click="showFeatureLimitDescTips(featureItem)" :disabled="!featureItem.limitDesc"
                  >限制说明</el-button
                >
              </div>
              <div class="wsp-padding-lr-3">
                <el-button
                  type="text"
                  @click="showRelationTeatCase(featureItem)"
                  :disabled="featureItem.testCaseCont === 0"
                  >测试用例</el-button
                >
              </div>
              <div class="wsp-padding-lr-3">
                <el-button type="text" @click="showFeatureSettingTips(featureItem)" :disabled="!featureItem.configStep"
                  >配置指导</el-button
                >
              </div>

              <div class="remove-btn">
                <el-button
                  v-if="featureItem.deliveryFeatureType !== 'REQUIRED'"
                  type="text"
                  class="remove-activie"
                  icon="el-icon-delete"
                  @click="removeFeature(featureItem.featureId)"
                ></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :key="drawerKey"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      :size="drawerSize ? drawerSize : '55%'"
      :before-close="handleCloseDrawer"
      direction="rtl"
    >
      <div class="relation-page-group">
        <div class="wsp-group-title">
          <div class="wsp-group-title-icon"></div>
          <div class="wsp-group-title-value" v-if="showPageType === 'addFeature'">新增功能</div>
          <div class="wsp-group-title-value" v-if="showPageType === 'showFeatureSettingTip'">功能配置指导</div>
          <div class="wsp-group-title-value" v-if="showPageType === 'showFeatureLimitDescTip'">限制说明</div>
        </div>
      </div>
      <div v-if="showPageType === 'addFeature'" class="drawer-content">
        <function-table
          :projectId="projectId"
          :selectFeatrueIdList="selectFeatrueIds"
          @selectAddConfirm="addSpecFuntion"
        ></function-table>
      </div>
      <div v-if="showPageType === 'showFeatureSettingTip'" class="drawer-content">
        <div class="drawer-tips show-document">
          <el-tabs v-model="activeName">
            <el-tab-pane label="文档" name="wordLink" v-if="showFeature.configStepLink">
              <sky-show-fei-shu-document-view
                :documentUrl="showFeature.configStepLink"
              ></sky-show-fei-shu-document-view>
            </el-tab-pane>
            <el-tab-pane label="文字" name="configStep"
              ><div class="drawer-tips-content">{{ showFeature.configStep }}</div></el-tab-pane
            >
            <el-tab-pane label="视频" name="video" v-if="showFeature.video">
              <video
                width="1280"
                height="720"
                controls=""
                :src="showFeature.video"
                :title="showFeature.featureName"
              ></video>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div v-if="showPageType === 'showFeatureLimitDescTip'" class="drawer-content">
        <div class="drawer-tips">
          <div class="tips-rl-question">限制说明</div>
          <div class="drawer-tips-content">{{ showFeature.limitDesc }}</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  InputNumber,
  Input,
  Select,
  Option,
  Tag,
  Button,
  Drawer,
  Dropdown,
  DropdownMenu,
  Tabs,
  TabPane,
  DropdownItem
} from 'element-ui'

import functionTable from '../../common/functionTable'

import { getPorjectPositionDetail } from '@/api/deliveryPosition'
import { getDetail } from '@/api/deliveryProject'
import { getPorjectFeatureDetail, createProjectRequirementFeature } from '@/api/deliveryRequiremnet'
import SkyShowFeiShuDocumentView from '@/components/SkyShowFeiShuDocumentView'

export default {
  name: 'SkyDeployStepViewRequiremnetCheck',
  props: {
    projectId: {
      type: String
    },
    industryId: {
      type: String
    }
  },
  mounted() {},
  components: {
    [InputNumber.name]: InputNumber,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    functionTable,
    SkyShowFeiShuDocumentView
  },
  data: function() {
    return {
      viewFeatureList: [],
      showPageType: null,
      handelFeature: null,
      featureList: [],
      featureValueList: [],
      selectFeatrueIds: [],
      featureTag: '全部',
      projectDetail: {},
      selectFeatureIdList: [],
      positionMap: {},
      positionIdList: [],
      drawerSize: null,
      showFeature: {},
      activeName: 'wordLink'
    }
  },
  created() {
    this.$emit('showBtns', {
      preStep: true,
      nextStep: true,
      saveStep: false,
      enableTabChange: true,
      enableSkipNext: true
    })
    this.getProjectDetail()
    this.getInitData()
  },
  methods: {
    getProjectDetail() {
      getDetail({ id: this.projectId }).then(res => {
        this.projectDetail = res.data.content
      })
    },
    handleClick(tab, event) {
      this.activeName = tab
    },
    getData() {
      var returnData = {
        projectId: this.projectId,
        featureList: this.featureList
      }
      return returnData
    },
    async gotoNextStep() {
      this.message = '点击了下一步'
      var data = this.getData()
      var commitFeature = this.featureList.filter(data => data.export)
      data.featureList = commitFeature

      var result = false
      await createProjectRequirementFeature(data)
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            result = true
          }
        })
        .catch(e => {
          result = false
        })
      return result
    },
    async gotoNextPreVliate() {
      return true
    },
    gotoPreStep() {
      this.message = '点击了上一步'
      return true
    },
    getInitData() {
      this.selectFeatrueIds = []
      const _this = this
      getPorjectPositionDetail({ id: this.projectId }).then(res => {
        for (const element of res.data.content) {
          _this.positionMap[element.id] = element
          this.positionIdList.push(element.id)
        }
        this.getFeatureList()
      })
    },
    getFeatureList() {
      this.featureList = []
      this.selectFeatrueIds = []
      getPorjectFeatureDetail({ id: this.projectId }).then(res => {
        for (const element of res.data.content) {
          if (!element.positionIdList) {
            element.positionIdList = []
          }
          this.selectFeatrueIds.push(element.featureId)
          // if (!element.export) {
          //   element.positionIdList = JSON.parse(JSON.stringify(this.positionIdList))
          // }
          this.featureList.push(element)
        }
        this.featureList //
        this.featureTag = '全部'
        this.reloadMap()
      })
    },
    reloadMap() {
      this.featureValueList = []
      this.selectFeatureIdList = []
      this.featureValueList.push('全部')
      this.featureList.reduce((acc, item) => {
        // 如果该类别不存在，则创建一个新数组
        if (!acc[item.valueDesc]) {
          this.featureValueList.push(item.valueDesc)
          acc[item.valueDesc] = []
        }
        this.selectFeatureIdList.push(item.featureId)
        // 将当前项添加到对应类别的数组中
        // acc[item.valueDesc].push(item)
        return acc
      }, {})
      this.featureViewList(this.featureTag)
    },
    clickHandelFeature(featureItem, index) {
      this.handelFeature = featureItem
    },
    changeExport(featureItem, index) {
      for (let index = 0; index < this.featureList.length; index++) {
        if (featureItem.featureId === this.featureList[index].featureId) {
          this.featureList[index].export = !this.featureList[index].export
          this.featureList.splice(index, 1, this.featureList[index])
        }
      }
    },
    showFeatureSettingTips(featureItem) {
      this.showFeature = featureItem
      this.drawerSize = '75%'
      this.showPageType = 'showFeatureSettingTip'
      if (this.showFeature.configStepLink) {
        this.activeName = 'wordLink'
      } else {
        this.activeName = 'configStep'
      }
      this.dialogVisible = true
    },
    showFeatureLimitDescTips(featureItem) {
      this.drawerSize = '55%'
      this.showFeature = featureItem
      this.showPageType = 'showFeatureLimitDescTip'
      this.dialogVisible = true
    },
    showRelationTeatCase(featureItem) {
      var params = {
        id: featureItem.featureId,
        featureId: featureItem.featureId,
        featureName: featureItem.featureName
      }

      this.$store.dispatch('showFeatureRelationTestCase', params)
    },
    addSpecFuntion(params) {
      for (const element of params.selectFunction) {
        const exists = this.featureList.some(obj => obj.featureId === element.id)

        if (!exists) {
          element.featureId = element.id
          element.featureBusiVersion = element.busiVersion
          element.positionIdList = []
          element.export = true
          this.featureList.push(element)
          this.selectFeatrueIds.push(element.id)
        }
      }

      this.reloadMap()
      this.handleCloseDrawer()
    },
    addFunction() {
      this.drawerSize = '55%'
      this.showPageType = 'addFeature'
      this.dialogVisible = true
    },
    removeFeature(featureId) {
      for (let index = 0; index < this.featureList.length; index++) {
        if (featureId === this.featureList[index].featureId) {
          this.featureList.splice(index, 1)
        }
      }

      for (let index = 0; index < this.selectFeatrueIds.length; index++) {
        if (featureId === this.selectFeatrueIds[index]) {
          this.selectFeatrueIds.splice(index, 1)
        }
      }
      this.reloadMap()
    },
    removeFuntionPosition(featureItem, featureIndex, postionId, positionIndex) {
      for (let index = 0; index < this.featureList.length; index++) {
        if (featureItem.featureId === this.featureList[index].featureId) {
          if (this.featureList[index].positionIdList.includes(postionId)) {
            this.featureList[index].positionIdList.splice(positionIndex, 1)
            this.featureList.splice(index, 1, this.featureList[index])
          }
        }
      }
    },
    handlePositionCommand(command) {
      for (let index = 0; index < this.featureList.length; index++) {
        if (this.handelFeature.featureId === this.featureList[index].featureId) {
          if (!this.featureList[index].positionIdList.includes(command)) {
            this.featureList[index].positionIdList.push(command)
            this.featureList.splice(index, 1, this.featureList[index])
          }
        }
      }
    },

    handleCloseDrawer() {
      this.showPageType = null
      this.dialogVisible = false
      this.showFeature = null
    },
    featureViewList(featureValue) {
      this.featureTag = featureValue
      if (featureValue === '全部') {
        this.viewFeatureList = this.featureList
      } else {
        this.viewFeatureList = this.featureList.filter(data => data.valueDesc === featureValue)
      }
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(deploy-step-view-requiremnet-check) {
  .case-requirement-content {
    height: 72vh;
    overflow: auto;
  }
  .show-document {
    height: 95vh;
    overflow: auto;
    padding: 0px !important;
  }
  .drawer-content {
    margin-left: 12px;
    height: 95vh;
  }
  .drawer-tips {
    padding: 12px 24px;
    .tips-rl-question {
      padding-top: 12px;
      margin-bottom: 12px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    .drawer-tips-content {
      word-break: break-word;
      white-space: pre-wrap;
      line-height: 24px;
      font-size: 12px;
    }
  }
  .content-tag {
    .tag-item {
      text-align: center;
      height: 28px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #7f7f7f;
      border-radius: 15px;
    }
    .active {
      // border: 1px solid #38a4f5;
      // background-color: #38a4f5;
      // color: #fff;
      background: center center #38a4f5;
      background-size: 104% 104%;
      color: #fff;
    }
  }
  .featur-active {
    // background: rgba(0, 82, 217, 0.0389);
  }
  .content-function {
    .function-item {
      position: relative;
      border-color: #e3e6eb;
      .function-item-icon {
        position: absolute;
        top: 0%;
        right: 0%;
        font-size: 36px;
      }
      .match-position {
        max-height: 54px;
        overflow-y: auto;
      }
      .function-item-content {
        height: 144px;
      }
      .funtion-item-toolbar {
        position: absolute;
        bottom: 0%;
        width: 100%;
        text-align: center;
      }
      .remove-btn {
        width: 40px;
        .remove-activie {
          display: none;
        }
        .remove-activie {
          color: #f13131 !important;
        }
      }
    }
    .function-item:hover .remove-activie {
      display: block;
    }

    .function-item:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
      border-color: #0052d9;
    }
  }
}
</style>
